import type { Table } from "@tanstack/react-table";
import { memo } from "react";

import { InvoicesFilters } from "@/components/shared/invoices-filters";
import { useExportHistory } from "@/providers/invoices";

import type { InvoiceTypeString } from "@/lib/constants/invoice-type";
import type { UseGetAllInvoicesData } from "@/queries/invoices/get-all";
import { useInvoiceTableInstanceContext } from "./table-instance-provider";

type Props = {
  data: any;
  table?: Table<any>;
  tableName: string;
  onFilter: React.Dispatch<React.SetStateAction<UseGetAllInvoicesData>>;
  filtersConfig: {
    showTypeFilter?: boolean;
    showStatusFilter?: boolean;
    showAccountFilter?: boolean;
    showSupplierFilter?: boolean;
    showExportsFilter?: boolean;
    showUploadButton?: boolean;
    showOcrReviewedFilter?: boolean;
    showExportAllButton?: boolean;
    autoFocus?: boolean;
  };
  showStartReviewButton?: boolean;
  filters: any;
  setFilters: any;
  globalSearch: string;
  setGlobalSearch: (value: string) => void;
  invoiceType?: InvoiceTypeString;
};

export const _InvoicesOverviewFilters = ({
  data,
  filtersConfig = {},
  showStartReviewButton = false,
  filters,
  setFilters,
  globalSearch,
  setGlobalSearch,
  invoiceType,
}: Props) => {
  const { table } = useInvoiceTableInstanceContext();

  const { exportHistory } = useExportHistory();

  return (
    <InvoicesFilters
      data={data}
      filters={filters}
      setFilters={setFilters}
      exportHistory={exportHistory}
      table={table}
      filtersConfig={filtersConfig}
      showStartReviewButton={showStartReviewButton}
      globalSearch={globalSearch}
      setGlobalSearch={setGlobalSearch}
      invoiceType={invoiceType}
    />
  );
};

export const InvoicesOverviewFilters = memo(_InvoicesOverviewFilters);
